import React from 'react';
import Udesk from 'Udesk';
import { Redirect } from 'react-router-dom';
import LayoutMenu from 'Component/common/layout-menu';
class semanticIntelligence extends React.Component {
    isRedirect(currentPath, toPath) {
        if (currentPath === toPath) {
            return true;
        }
        return false;
    }
    render() {
        let {
            route,
            location,
            sdkOptions,
        } = this.props;

        let {
            locales
        } = this;

        let navLists = [];
        //概念词
        if (Udesk.data.init.user && Udesk.data.init.user.hasFeature("semantic:conceptWords:root")) {
            navLists.push({
                text: locales.components.pages.conceptWord.title,
                pathName: "salesConceptWord",
                isActive: (match, location) => {
                    return location.pathname.includes("/concept-word");
                }
            });
        }
        if (Udesk.data.init.user && Udesk.data.init.user.hasFeature("semantic:semanticTag:root")) {
            navLists.push({
                text: locales.components.pages.semanticTags.title,
                pathName: "salesSemanticTagsIndex",
                isActive: (match, location) => {
                    return location.pathname.includes("/semantic-tags");
                }
            });
        }
        if (Udesk.data.init.user && Udesk.data.init.user.hasFeature("semantic:imformation:root")) {
            navLists.push({
                text: locales.components.pages.informationEntities.title,
                pathName: "salesInformationEntitiesIndex",
                isActive: (match, location) => {
                    return location.pathname.includes("/information-entities");
                }
            });
        }

        // if (Udesk.data.init.user && Udesk.data.init.user.hasFeature("semantic:WordsMining:root")) {
        //     navLists.push({
        //         text: /* 话术挖掘 */locales.pages.semanticIntelligence.speechMining,
        //         pathName: "wordsMining",
        //         isActive: (match, location) => {
        //             return location.pathname.includes("/words-mining");
        //         }
        //     });
        // }
        if (this.isRedirect(route.path, location.pathname) && sdkOptions.props.landingPath != null) {
            let toPath = location.pathname + sdkOptions.props.landingPath;
            return (
                <Redirect to={toPath} sdkOptions={sdkOptions} />
            );
        } else if (navLists.length > 0 && this.isRedirect(route.path, location.pathname)) {
            let toPath = Udesk.ui.routing.getRouteFirstBottomedChildRoutePath({
                routeName: navLists[0].pathName
            });
            return (
                <Redirect to={toPath} sdkOptions={sdkOptions} />
            );
        } else {
            return (
                <div className="semantic-intelligence">
                    {/* <div className="semantic-intelligence-nav col-md-2 col-sm-3 col-xs-12">
                        <NavBar navLists={navLists} classNames="semantic-intelligence-nav-container" navItemClassNames="semantic-intelligence-nav-item" activeClassNames="semantic-intelligence-nav-item-active" />
                    </div>
                    <div className="semantic-intelligence-content col-md-10 col-sm-9 col-xs-12">
                        <For each="route" index="i" of={routes}>
                            <If condition={!route.authCode || (route.authCode && Udesk.data.init.user.hasFeature(route.authCode))}>
                                <SubRoutes key={i} route={route} />
                            </If>
                        </For>
                    </div> */}
                    <LayoutMenu {...this.props} navLists={navLists} menuTitle={locales.components.pages.menuTitleList.semanticIntelligence} />
                </div>
            );
        }
    }
}

export default Udesk.react.udeskify(semanticIntelligence);